"use client";
import { ChevronRight } from "lucide-react";
import Link from "next/link";
import { Typography } from "@/components/shared/typography/typography";

interface SimpleTitleProps {
  title: string;
  href?: string;
  openInNewTab?: boolean;
  onClick?: () => void;
}

export function SimpleTitle({
  title,
  href,
  openInNewTab = false,
  onClick,
}: SimpleTitleProps) {
  const words = title.trim().split(" ");
  const lastWord = words.pop() || "";
  const firstPart = words.join(" ");

  const TitleContent = (
    <Typography variant="h3">
      {firstPart}{" "}
      <span className="whitespace-nowrap">
        {lastWord}{" "}
        {href && (
          <ChevronRight className="inline h-4 w-4 text-black md:h-6 md:w-6" />
        )}
      </span>
    </Typography>
  );

  if (!href) {
    return TitleContent;
  }

  if (typeof onClick === "function") {
    return (
      <Link
        href={href}
        className="transition-opacity"
        target={openInNewTab ? "_blank" : undefined}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault();
          onClick?.();
        }}>
        {TitleContent}
      </Link>
    );
  }

  return (
    <Link
      href={href}
      className="transition-opacity"
      target={openInNewTab ? "_blank" : undefined}
      rel={openInNewTab ? "noopener noreferrer" : undefined}>
      {TitleContent}
    </Link>
  );
}
